import store from '../../store';
import * as types from '../../actions/actionTypes';
import {setAssignQuoteCloneMode, toggleShowAssignQuotePopup} from '../../actions/assignPopupFunctions';
import {setNetworkConnection} from '../../actions/serverFunctions';
import {forceLoaderDisable, loaderDisable, loaderEnable} from '../../bvcomponents/ui/loaderView';
import {reportNonFatalError} from './errorReporter';
import {preserveCurrentSqftDataForRecovery} from './sqftRecoverySnapshot';

let recoveryPopupShown = false;
const fatalErrorSaveAsNewQuoteFlag = '__fatalErrorSaveAsNewQuote';
export const fatalErrorRecoveryRestoreEvent = 'fatal-error-recovery-restore';

export function closeMessageBox() {
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: {
      visible: false,
    },
  });
}

export function reloadWithQuote(jobId) {
  const url = new URL(window.location.href);

  url.searchParams.delete('quoteId');
  url.searchParams.delete('jobId');

  if (jobId) {
    // Hosted dashboard pages resolve `p` into document.kvConfig.jobId before React boots.
    // Keep jobId too so local dev can reload saved recovery quotes without backend HTML rendering.
    url.searchParams.set('p', jobId);
    url.searchParams.set('jobId', jobId);
  }

  const nextUrl = url.toString();

  if (nextUrl === window.location.href) {
    window.location.reload();
    return;
  }

  window.location.assign(nextUrl);
}

export function saveCurrentQuote() {
  closeMessageBox();
  loaderEnable('loader.savingQuoteText');
  const {saveQuote} = require('../../api/server-api');

  saveQuote({
    submit: true,
    showReceipt: false,
  }).then((response) => {
    loaderDisable();
    reloadWithQuote(response && response.jobId);
  }).catch((error) => {
    // saveQuote() already shows its own "Server error" popup and rethrows,
    // so this only needs to stop the loader and get the failure into the
    // same fatal-error log as every other error - it was silently dropped
    // before, which hid recovery-retry failures from monitoring entirely.
    loaderDisable();
    reportNonFatalError('recovery-save-quote-failed', error);
  });
}

export function openSaveAsNewQuotePopup() {
  closeMessageBox();
  window[fatalErrorSaveAsNewQuoteFlag] = true;
  store.dispatch(setAssignQuoteCloneMode(true));
  store.dispatch(toggleShowAssignQuotePopup(true, 'save'));
}

export function returnToFatalErrorRecoveryPopup() {
  clearFatalErrorSaveAsNewQuoteReloadFlag();
  store.dispatch(setAssignQuoteCloneMode(false));
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: buildFatalErrorRecoveryMessageBoxState('review'),
  });
  window.dispatchEvent(new Event(fatalErrorRecoveryRestoreEvent));
}

export function shouldReloadAfterFatalErrorSaveAsNewQuote() {
  return window[fatalErrorSaveAsNewQuoteFlag] === true;
}

export function clearFatalErrorSaveAsNewQuoteReloadFlag() {
  window[fatalErrorSaveAsNewQuoteFlag] = false;
}

export function buildFatalErrorRecoveryMessageBoxState(initialStage = 'prompt') {
  const messageBoxState = {
    fatalErrorRecovery: true,
    visible: true,
  };

  if (initialStage !== 'prompt') {
    messageBoxState.fatalErrorRecoveryInitialStage = initialStage;
  }

  return messageBoxState;
}


export function showFatalErrorRecoveryPopup() {
  if (recoveryPopupShown) {
    return;
  }

  recoveryPopupShown = true;
  preserveCurrentSqftDataForRecovery();
  setTimeout(() => {
    store.dispatch({
      type: types.CHANGE_MESSAGE_BOX,
      payload: buildFatalErrorRecoveryMessageBoxState(),
    });
  }, 0);
}

export function handleNetworkConnectionError() {
  setTimeout(() => {
    forceLoaderDisable();
    store.dispatch(setNetworkConnection(false));
  }, 0);
}
